// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"WmOPjfeDjt2uEhmYLivh","switch":"cgrk4_vN89rHl5MyY83R"};